"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const icon_1 = __importDefault(require("../../buttons/multi_pill/icon"));
const graphql_js_1 = require("../../../requests/graphql.js");
const cookies_1 = require("../../../services/cookies"); // TODO: Add after rebase.
const index_js_1 = __importDefault(require("../../../services/error_handler/index.js"));
const dispatchers_js_1 = require("../../../utility/dispatchers.js");
const useSkipFirstRender_1 = __importDefault(require("../../hooks/useSkipFirstRender"));
const PILL_OPTS = [{ icon: 'light', value: 'light' }, { icon: 'device', value: 'device' }, { icon: 'dark', value: 'dark' }];
const UIPreferenceSelector = ({ signedIn }) => {
    const uiTheme = (0, cookies_1.getCookie)('ui_theme');
    const [selectedVal, setSelectedVal] = (0, react_1.useState)(uiTheme || 'device');
    const htmlElRef = (0, react_1.useRef)(null);
    const handleResponse = (0, react_1.useCallback)(({ value }) => {
        const currentTime = Date.now();
        const sixMonths = 182 * 24 * 60 * 60 * 1000;
        const expires = currentTime + sixMonths;
        const date = new Date(expires);
        if (!signedIn) {
            setSelectedVal(value);
            (0, cookies_1.setCookie)('ui_theme', value, date);
            (0, dispatchers_js_1.summonGlobalMessenger)({ msg: 'Preference saved.', type: 'success' });
        }
        else {
            (0, graphql_js_1.graphMutate)({ t: 'update_user_ui_theme' }, { ui_theme: value })
                .then(() => {
                setSelectedVal(value);
                (0, cookies_1.setCookie)('ui_theme', value, date);
                (0, dispatchers_js_1.summonGlobalMessenger)({ msg: 'Preference saved.', type: 'success' });
            })
                .catch((err) => {
                (0, index_js_1.default)('UIPreferenceSelector handleResponse', err);
                (0, dispatchers_js_1.summonGlobalMessenger)({ msg: 'Oops, something went wrong. Try again later.', type: 'error' });
            });
        }
    }, [signedIn]);
    // // update theme anytime selectedVal changes
    (0, useSkipFirstRender_1.default)({
        callback: () => {
            htmlElRef.current = window.document.querySelector('html');
            const value = selectedVal === 'device' ? 'dark light' : selectedVal;
            htmlElRef.current.dataset.theme = value;
        }, dependencies: [selectedVal, uiTheme],
    });
    // logged out users might get cached version of the html page.
    // If that is the case, update the html to cookie value
    (0, react_1.useEffect)(() => {
        if (signedIn)
            return null;
        const htmlValue = window.document.querySelector('html');
        htmlElRef.current = htmlValue;
        const theme = uiTheme === 'device' ? 'dark light' : uiTheme;
        const isDifferingValue = htmlValue.dataset.theme !== theme;
        if (isDifferingValue) {
            htmlElRef.current.dataset.theme = theme;
        }
    }, [signedIn, uiTheme]);
    (0, react_1.useEffect)(() => {
        const handleEvent = (e) => {
            setSelectedVal(e.detail);
        };
        document.addEventListener('uiThemeCookieSet', handleEvent);
        return () => {
            document.removeEventListener('uiThemeCookieSet', handleEvent);
        };
    }, []);
    return (react_1.default.createElement(icon_1.default, { onChange: ({ value }) => handleResponse({ value }), options: PILL_OPTS, selectedVal: selectedVal }));
};
exports.default = UIPreferenceSelector;
